"use client";

import "@/styles/image-skeleton.css";

import { Shimmer } from "@/components/ai-elements/shimmer";
import { cn } from "@/lib/utils";

export function ImageSkeleton({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  return (
    <div
      className={cn(

        "ai-image-skeleton flex aspect-square w-64 items-center justify-center sm:w-80",
        className,
      )}
      role="status"
      aria-label={label}
    >
      <span className="ai-image-skeleton-blob" aria-hidden />
      <span className="ai-image-skeleton-blob" aria-hidden />
      <span className="ai-image-skeleton-blob" aria-hidden />

      {/* 文字压在光斑之上：z-10 少了会被模糊的色块盖住 */}
      <Shimmer className="relative z-10 text-sm">{label}</Shimmer>
    </div>
  );
}
